import React from 'react'
import PropTypes from 'prop-types'
import { ComplianceForm } from './components/ComplianceForm'

const TenantComplianceDialog = ({ onClose }) => (
  <wb-modal mode="edit" class="tenant-dialog">
    <wb-modal-content
      headline="Tenant Compliance Info"
      class="tenant-dialog__content"
    >
      <ComplianceForm />
    </wb-modal-content>
    <wb-modal-footer class="tenant-dialog__footer">
      <button
        type="button"
        className="wb-button wb-button--secondary wb-button--large"
        onClick={onClose}
      >
        Close
      </button>
    </wb-modal-footer>
  </wb-modal>
)
TenantComplianceDialog.propTypes = {
  onClose: PropTypes.func,
}

export default TenantComplianceDialog
